import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messagesRU from '@/locales/ru'
import messagesEN from '@/locales/en'
import store from '@/store/store'
import pluralization from './pluralization'

const messages = {
  ru: messagesRU,
  en: messagesEN
}

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: store.state.locale || 'ru',
  messages,
  pluralizationRules: pluralization
})

export default i18n



// WEBPACK FOOTER //
// ./src/pkg/i18n/i18n.js